import { reducer as alertReducer, alert } from './alert'
import {
  actions as appShellUiActions,
  reducer as appShellUiReducer,
  updateUi,
} from './ui'
import { _auth, actions, reducer } from './auth'

export {
  _auth,
  actions,
  reducer,
  alert,
  alertReducer,
  updateUi,
  appShellUiActions,
  appShellUiReducer,
}



// WEBPACK FOOTER //
// ./~/label-insight-app-shell/src/Application/lib/index.js